import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import EjariActionSuccessPage from "../EjariActionSuccessPage";
import { EjariContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import { EjariApi } from "@eres/ejari-api";
import { toast } from "react-toastify";
import { downloadTenancyContractByNumber } from "@my-dld/actions/PropertyActions";

interface Props extends RoutedViewProps<any> {

}


interface State {

}

class NewContractComplete extends Component<Props, State> {
	static contextType = EjariContractContext;
	context!: React.ContextType<typeof EjariContractContext>;
	inp = React.createRef<HTMLInputElement>();

	render() {
		const { newContract, tenantApproval, feePayMode } = this.context;
		const payUrl = EjariApi.getEjariPaymentShortUrl( newContract! );
		const canDownload = newContract?.ContractNumber && newContract?.ContractKey;
		return <EjariActionSuccessPage
			message={ Strings.contract_added_successfully }
			title={ Strings.create_new_contract }
			hideButton={ false }
			buttonTitle={ Strings.home }
			refreshProperty={ true }
			extra={ <div className="refn-box">
				{ Strings.contract_number }: <span>{ newContract?.ContractNumber }</span>
			</div> }
			{ ...this.props }
		>
			{ tenantApproval && <p>
				{ Strings.tenant_contract_reg }
			</p> }
			{ feePayMode === "tenant" && <>
				<div className="alert alert-info">
					{ Strings.inactive_contract }
				</div>
				<div className={ "d-flex " }>
					<input
						readOnly={ true }
						ref={ this.inp }
						className={ "form-control" }
						value={ payUrl }
					/>
					<button
						onClick={ ( e ) => {
							if ( this.inp.current ) {
								this.inp.current.select();
								this.inp.current.setSelectionRange( 0, 99999 );
								document.execCommand( "copy" );
								toast.dark( Strings.copied );
							}
						} }
						className={ "btn btn_1 btn_style1" }>
						<i className={ "fa fa-copy" }/>
					</button>
				</div>

			</> }
			{ feePayMode === "paid" && <>
				<div className="alert alert-info">
					{ Strings.contract_activated }
				</div>
				{ canDownload &&
					<div className={ "form-group" }>
						<button
							className="btn btn_2 btn_style2" onClick={ this.download }>
							{ Strings.download_certificate }
						</button>
					</div>
				}
			</> }


		</EjariActionSuccessPage>;
	}

	download = () => {
		downloadTenancyContractByNumber( this.context.newContract?.ContractNumber!, this.context.newContract?.ContractKey! );
	};

}


export default NewContractComplete;
